class AMCaptcha {

  constructor({theme = 'light', render_element_or_id = 'recaptcha-el'}) {
    //
    this.gl_api_url = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
    this.captcha_sitekey = "6LeRUzsjAAAAANUHNEY6VkUXmMo_wlrDK5SUoFUV";
    this.verify_url = "https://internalapi.activamedia.com.sg/v1/recaptcha/verify";
    this.theme = theme;
    this.render_element_or_id = render_element_or_id;
    this.widgetId='';
    this.widgetId_reseted = false;

    this.defineOnloadCallBack();
    this.loadJsFile();
  }

  defineOnloadCallBack() {
    window.onloadCallback = () => {
      console.log('api loaded');
    }
  }

  /**
   * insert and load the Google api js file
   */
  loadJsFile() {
    // global js file, load one time
    if (document.querySelectorAll(`script[src="${this.gl_api_url}"]`).length === 0) {
      let scriptEl = document.createElement('script');
      scriptEl.setAttribute("src", this.gl_api_url);
      scriptEl.setAttribute("type", "text/javascript");
      scriptEl.setAttribute("async", 'true');
      scriptEl.setAttribute("defer", 'true');
      document.body.appendChild(scriptEl);
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  /**
   * rendering google captcha
   */
  async render() {
    while (true) {
      await this.sleep(200);
      if (typeof grecaptcha !== 'undefined' && grecaptcha !== undefined
        && typeof grecaptcha.render === "function") {
        this.widgetId = grecaptcha.render(
          this.render_element_or_id,
          {
            sitekey: this.captcha_sitekey,
            theme: this.theme
          });
        break;
      }
      console.info("checking grecaptcha undefined");
    }
  }

  /**
   * reset google captcha
   */
  reset() {
    if (this.widgetId_reseted === false) {
      grecaptcha.reset(this.widgetId);
      this.widgetId_reseted = true;
    }
  }

  getResponse() {
    try {
      return grecaptcha.getResponse(this.widgetId);
    } catch (e) {}
  }

  async verifyRecaptcha(token) {
    return await fetch(this.verify_url, {
      method: 'post', body: JSON.stringify({"token": token}),
      headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
    }).then((response) => response.json());
  }
}

module.exports = AMCaptcha;